import { Component } from '@angular/core';

@Component({
  templateUrl: './extend.component.html',
  styleUrls: ['./extend.component.css'],
})
export class ExtendComponent {

  constructor() { }

}
